import React from 'react';
import {
  Skeleton,
  SkeletonCard,
  SkeletonMetricCard,
  SkeletonTabela,
} from '../Skeleton';

/**
 * Espelha o layout do Dashboard: 2 fileiras de 4 métricas, 3 painéis,
 * 2x2 painéis e a tabela de atendentes. Substitui o spinner de 128px que
 * bloqueava a tela inteira.
 */
export default function DashboardSkeleton() {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="grid grid-cols-2 gap-2 sm:gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonMetricCard key={i} />
        ))}
      </div>

      <div className="grid grid-cols-2 gap-2 sm:gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonMetricCard key={i} />
        ))}
      </div>

      <div className="grid grid-cols-1 gap-2 sm:gap-4 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <SkeletonCard key={i} linhas={4} />
        ))}
      </div>

      <div className="grid grid-cols-1 gap-3 sm:gap-6 lg:grid-cols-2">
        <SkeletonCard linhas={5} />
        <SkeletonCard linhas={5} />
      </div>

      <div>
        <Skeleton className="h-5 w-40 mb-3" />
        <SkeletonTabela colunas={4} linhas={4} />
      </div>

      <div className="grid grid-cols-2 gap-2 sm:gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonCard key={i} linhas={1} titulo />
        ))}
      </div>
    </div>
  );
}
